export const APPLYBOARD_URL = 'https://www.applyboard.com';

export const STUDENTS_URL = `${APPLYBOARD_URL}/studyabroad`;
export const RECRUIT_URL = `${APPLYBOARD_URL}/recruitment-partners`;
export const SCHOOLS_URL = `${APPLYBOARD_URL}/institution`;

export const SOLUTIONS_URL = `${APPLYBOARD_URL}/360solutions`;
export const ABOUT_URL = `${APPLYBOARD_URL}/our-story`;
export const CAREERS_URL = `${APPLYBOARD_URL}/careers`;
export const PRESS_URL = `${APPLYBOARD_URL}/press`;
export const CONTACT_URL = `${APPLYBOARD_URL}/contact`;

export const LOGIN_URL = '/account';
export const REGISTER_URL = '/register';

export const BLOG_URL = `${APPLYBOARD_URL}/blog`;

// New Services Header
export const GIC_URL = `${APPLYBOARD_URL}/discover/gic`;
export const TESTS_URL = 'https://tests.applyboard.com/en-ca';
export const TRAINHUB_URL = 'https://trainhub.com/';
